module.exports = __webpack_public_path__ + "static/media/schody16 - schody drewniane zabiegowe nakladane.fa64795c.jpg";